import styled from "styled-components";

export const FooterWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  background-color: #00081e;
  flex-direction: column;
  align-items: center;
  padding-bottom: 36px;
  margin-top: 200px;
  /* The newsletter's Reveal wrapper must span the footer, or the card's
     percentage width resolves against a shrink-to-fit box. */
  .newsletter-reveal {
    align-self: stretch;
  }
  @media (max-width: 768px) {
    margin-top: 110px;
    padding-bottom: 18px;
  }
`;
